import IOffer from 'api/interfaces/offers/IOfferGet';

export default (offers: IOffer[]): { value: any; label: string }[] =>
  offers.map((x: IOffer) => ({
    value: x.id,
    label: `${x.targetName}`,
  }));
